import React from 'react';
import importer from '../../helpers/importer';
import './Auth.scss';
//#region COMPONENTS
import { Navigate, Route, Routes } from 'react-router-dom';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import LogIn from './Login/LogIn';
import ResetPassword from './ResetPassword/ResetPassword';
//#endregion
//MODELS
import Datetime from '../../helpers/datetime';

const Auth = () => {
    //METHODS
    const getCurrentSeason = () => {
        const winter = "1222", spring = "0321", summer = "0621", autumn = "0923";
        const today = new Datetime();
        const dayClass = today.getMonth() + today.getDay(); //"1101"

        let authClass = "default";

        if (dayClass >= winter || dayClass < spring) {
            authClass = "winter";
        }
        else if (dayClass >= spring && dayClass < summer) {
            authClass = "spring";
        }
        else if (dayClass >= summer && dayClass < autumn) {
            authClass = "summer";
        } else if (dayClass >= autumn && dayClass < winter) {
            authClass = "autumn";
        }

        return authClass;
    };

    //the login has its own look (a panel over a seasonal background image): it ignores the theme of the app and always uses the light tokens
    React.useEffect(() => {
        const root = document.documentElement;
        const previous = root.getAttribute('data-theme');

        root.setAttribute('data-theme', 'light');

        return () => previous ? root.setAttribute('data-theme', previous) : root.removeAttribute('data-theme');
    }, []);

    return (
        <div id="Auth" className={getCurrentSeason()} >
            <div className='flex-column centered'>
                <img width={240} src={importer.img.require('fullLogo.svg')} alt="WebGEST SRL" />

                <Routes >
                    <Route path="/" element={<LogIn /*login = {props.login}*/ />} />
                    <Route path="/forgotPassword" element={<ForgotPassword />} />
                    <Route path="/resetPassword/:otp" element={<ResetPassword />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </div>
        </div >
    );
};
export default React.memo(Auth);